import {
  DashboardOutlined,
  AppstoreOutlined,
  SolutionOutlined,
  StarOutlined,
  BarChartOutlined,
  TrophyOutlined,
  TagsOutlined,
  SearchOutlined,
  RocketOutlined,
  PlusCircleOutlined,
  WalletOutlined,
  CreditCardOutlined,
  SwapOutlined,
  CalendarOutlined,
  ShoppingCartOutlined,
  QuestionCircleOutlined,
  ContactsOutlined,
  InboxOutlined,
  TeamOutlined,
} from "@ant-design/icons";

// Each top-level entry is either:
// - a standalone link:  { to: "/route" }
// - a standalone locked link: { locked: true }
// - a group with sub-items: { items: [...] }
// Sub-items are either: { to }, { locked: true } or { action: "topup" } (opens the real top-up modal)

export const USER_NAV_GROUPS = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: DashboardOutlined,
    to: "/dashboard",
  },
  {
    key: "apps",
    label: "Apps",
    icon: AppstoreOutlined,
    items: [
      { key: "my-apps", label: "My Apps", to: "/app", icon: AppstoreOutlined },
      { key: "app-profile", label: "App Profile", locked: true, icon: SolutionOutlined },
      { key: "rates-reviews", label: "Rates & Reviews", locked: true, badge: "beta", icon: StarOutlined },
      { key: "category-rankings", label: "Category Rankings", locked: true, icon: BarChartOutlined },
      { key: "top-charts", label: "Top Charts", locked: true, badge: "new", icon: TrophyOutlined },
    ],
  },
  {
    key: "keywords",
    label: "Keywords",
    icon: TagsOutlined,
    topNavLocked: true,
    items: [
      { key: "my-keywords", label: "My Keywords", locked: true, icon: TagsOutlined },
      { key: "keywords-finder", label: "Keywords Finder", locked: true, icon: SearchOutlined },
    ],
  },
  {
    key: "campaigns",
    label: "Campaigns",
    icon: RocketOutlined,
    topNavLocked: true,
    items: [
      { key: "my-campaigns", label: "My Campaigns", locked: true, icon: RocketOutlined },
      { key: "add-campaign", label: "Add New Campaign", locked: true, icon: PlusCircleOutlined },
    ],
  },
  {
    key: "finance",
    label: "Finance",
    icon: WalletOutlined,
    topNavLocked: true,
    items: [
      { key: "topup", label: "Top-Up Balance", action: "topup", icon: WalletOutlined },
      { key: "priceplans", label: "Priceplans", locked: true, icon: CreditCardOutlined },
      { key: "my-transactions", label: "My Transactions", locked: true, icon: SwapOutlined },
      { key: "my-profile", label: "My Profile", locked: true, icon: TeamOutlined },
    ],
  },
  {
    key: "other",
    label: "Other",
    icon: null,
    items: [
      { key: "payment-calendar", label: "Payment Calendar", to: "/order-aso", icon: CalendarOutlined },
      { key: "orders", label: "Orders", to: "/orders", icon: ShoppingCartOutlined },
      { key: "faq", label: "FAQ", to: "/faq", icon: QuestionCircleOutlined },
      { key: "contacts", label: "Contacts", to: "/contacts", icon: ContactsOutlined },
      { key: "inventory", label: "Inventory", to: "/inventory", icon: InboxOutlined },
    ],
  },
];

export const ADMIN_NAV_GROUPS = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: DashboardOutlined,
    locked: true,
  },
  {
    key: "apps",
    label: "Apps",
    icon: AppstoreOutlined,
    items: [
      { key: "all-apps", label: "All Apps", to: "/apps", icon: AppstoreOutlined },
      { key: "app-profile", label: "App Profile", locked: true, icon: SolutionOutlined },
      { key: "rates-reviews", label: "Rates & Reviews", locked: true, badge: "beta", icon: StarOutlined },
      { key: "category-rankings", label: "Category Rankings", locked: true, icon: BarChartOutlined },
      { key: "top-charts", label: "Top Charts", locked: true, badge: "new", icon: TrophyOutlined },
    ],
  },
  {
    key: "keywords",
    label: "Keywords",
    icon: TagsOutlined,
    topNavLocked: true,
    items: [
      { key: "my-keywords", label: "My Keywords", locked: true, icon: TagsOutlined },
      { key: "keywords-finder", label: "Keywords Finder", locked: true, icon: SearchOutlined },
    ],
  },
  {
    key: "campaigns",
    label: "Campaigns",
    icon: RocketOutlined,
    topNavLocked: true,
    items: [
      { key: "my-campaigns", label: "My Campaigns", locked: true, icon: RocketOutlined },
      { key: "add-campaign", label: "Add New Campaign", locked: true, icon: PlusCircleOutlined },
    ],
  },
  {
    key: "finance",
    label: "Finance",
    icon: WalletOutlined,
    topNavLocked: true,
    items: [
      { key: "topup", label: "Top-Up Balance", locked: true, icon: WalletOutlined },
      { key: "priceplans", label: "Priceplans", locked: true, icon: CreditCardOutlined },
      { key: "transactions", label: "Transactions", locked: true, icon: SwapOutlined },
    ],
  },
  {
    key: "other",
    label: "Other",
    icon: null,
    items: [
      { key: "users", label: "Users", to: "/admin", icon: TeamOutlined },
      { key: "orders", label: "Orders", to: "/orders-panel", icon: ShoppingCartOutlined },
      { key: "payment-calendar", label: "Payment Calendar", to: "/order-aso-edit", icon: CalendarOutlined },
      { key: "faq", label: "FAQ", to: "/faq-edit", icon: QuestionCircleOutlined },
      { key: "contacts", label: "Contacts", to: "/contact-edit", icon: ContactsOutlined },
    ],
  },
];
